import { Input, Textarea, Box } from "@chakra-ui/react";
import styles from "./input.module.scss";
import { useState } from "react";

type FormInputProps = {
  label: string;
  name: string;
  multiline?: boolean;
  value: string;
  icon: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  type?: string;
};

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  multiline = false,
  value,
  icon,
  onChange,
  type = "text",
}) => {
  const [isFocus, setIsFocus] = useState(false);

  // Generate unique ID from name for label association
  const inputId = `contact-${name}`;

  // Map input names to appropriate autocomplete values
  const getAutocomplete = (fieldName: string) => {
    const autocompleteMap: { [key: string]: string } = {
      name: 'name',
      email: 'email',
      subject: 'off',
      message: 'off',
    };
    return autocompleteMap[fieldName] || 'off';
  };

  return (
    <div className={styles.textInput}>
      <div className={`${styles.inputWrapper} ${isFocus ? styles.focus : ''}`}>
        <div className={styles.inputContainer}>
          <div className={styles.inputFocus}></div>
          <Box position="relative">
            <Box
              position="absolute"
              left="12px"
              top="50%"
              transform="translateY(-50%)"
              className={styles.iconContainer}
              zIndex={1}
            >
              <i className={`pe-7s-${icon} pe-7s ${styles.icon}`}></i>
            </Box>
            {multiline ? (
              <Textarea
                id={inputId}
                onFocus={() => setIsFocus(true)}
                onBlur={() => setIsFocus(false)}
                onChange={onChange}
                value={value}
                name={name}
                required
                placeholder={label}
                autoComplete={getAutocomplete(name)}
              />
            ) : (
              <Input
                id={inputId}
                onFocus={() => setIsFocus(true)}
                onBlur={() => setIsFocus(false)}
                onChange={onChange}
                type={type}
                value={value}
                name={name}
                required
                placeholder={label}
                autoComplete={getAutocomplete(name)}
              />
            )}
          </Box>
        </div>
      </div>
      <label htmlFor={inputId} className={styles.fieldLabel}>
        {label} <span className={styles.required}>*</span>
      </label>
    </div>
  );
};

export default FormInput;
